import { Banners, type BannerV3 } from "@hubble/widgets";
import { useNavigate } from "@solidjs/router";
import { JSX } from "solid-js";
import { useAnalyticsService } from "~/context/analytics_service_context";
import { getCategorySlugFromCategoryName } from "~/utils/common";
import { useIsDesktop } from "~/utils/hooks/use_is_desktop";
import { useHomeWebstoreTelescopeContext } from "../context/home_webstore_telescope_context";

export function StoreBanners(): JSX.Element {
  const { routeData, onBrandClick } = useHomeWebstoreTelescopeContext();
  const navigate = useNavigate();
  const analyticsService = useAnalyticsService();
  const isDesktop = useIsDesktop();

  const banners = () => routeData()?.banners ?? [];

  const logBannerAnalytics = (event: string, banner: BannerV3) => {
    analyticsService.logEvent(event, {
      bannerId: banner.id,
      bannerType: banner.type,
      bannerProductId: banner.type === "BRAND" ? banner.brandKey : undefined,
      bannerCategoryName:
        banner.type === "CATEGORY" ? banner.categoryName : undefined,
      bannerLink: banner.type === "CAMPAIGN" ? banner.externalLink : undefined,
    });
  };

  const onBannerClick = (banner: BannerV3) => {
    logBannerAnalytics("banner_clicked", banner);

    switch (banner.type) {
      case "BRAND":
        onBrandClick(banner.brandKey);
        break;
      case "CATEGORY":
        navigate(
          `/shop-by-category/${getCategorySlugFromCategoryName(banner.categoryName)}`
        );
        break;
      case "CAMPAIGN":
        if (banner.externalLink) {
          window.open(banner.externalLink, "_blank");
        }
        // No externalLink means a static banner - no action.
        break;
    }
  };

  return (
    <div class="w-full pb-4 pt-6 lg:max-w-[1056px]">
      <Banners
        banners={banners}
        isDesktop={isDesktop}
        mobileGutterPx={12}
        onBannerClick={onBannerClick}
        onBannerViewed={(banner) => logBannerAnalytics("banner_viewed", banner)}
      />
    </div>
  );
}
